var map = {
	"./DemoObject": "C8u6",
	"./DemoObject.js": "C8u6"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Nosr";


//////////////////
// WEBPACK FOOTER
// ./src/models ^\.\/.*$
// module id = Nosr
// module chunks = 1